import reactLogo     from '../assets/img/react.svg';
import nodeLogo      from '../assets/img/nodejs.svg';
import jsLogo        from '../assets/img/javascript.svg';
import tsLogo        from '../assets/img/typescript.svg';
import mongoLogo     from '../assets/img/mongoDB.svg';
import htmlLogo      from '../assets/img/html.svg';
import cssLogo       from '../assets/img/css.svg';
import bootstrapLogo from '../assets/img/bootstrap.svg';
import angularLogo   from '../assets/img/angular.svg';
import mysqlLogo     from '../assets/img/mysql.svg';
import wordpressLogo from '../assets/img/wordpress2.svg';
import phpLogo       from '../assets/img/php2.svg';
import restApiLogo   from '../assets/img/rest_api3.svg';
import githubLogo    from '../assets/img/github3.svg';
import figmaLogo     from '../assets/img/figma2.svg';

export const stackData = [
  { name: 'React',       logo: reactLogo },
  { name: 'Node.js',     logo: nodeLogo },
  { name: 'JavaScript',  logo: jsLogo },
  { name: 'TypeScript',  logo: tsLogo },
  { name: 'MongoDB',     logo: mongoLogo },
  { name: 'HTML5',       logo: htmlLogo },
  { name: 'CSS3',        logo: cssLogo },
  { name: 'Bootstrap',   logo: bootstrapLogo },
  { name: 'Angular',     logo: angularLogo },
  { name: 'MySQL',       logo: mysqlLogo },
  { name: 'WordPress',   logo: wordpressLogo },
  { name: 'PHP',         logo: phpLogo },
  { name: 'REST APIs',   logo: restApiLogo },
  { name: 'Git',         logo: githubLogo },
  { name: 'Figma',       logo: figmaLogo },
];
